import { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { FileStack } from "lucide-react";
import BackButton from "@/components/BackButton";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import PaymentAccountsTab from "@/components/PaymentAccountsTab";
import CompanySettingsTab from "@/components/CompanySettingsTab";
import UnifiedAccountsTab from "@/components/UnifiedAccountsTab";

const SupplierMasterPage = () => {
  const { companyId } = useParams<{ companyId: string }>();
  const [searchParams] = useSearchParams();
  const initialTab = searchParams.get("tab") === "payment" ? "payment"
    : searchParams.get("tab") === "settings" ? "settings"
    : "accounts";
  const [companyName, setCompanyName] = useState("");

  useEffect(() => {
    if (!companyId) return;
    supabase.from("company_masters").select("name").eq("id", companyId).single()
      .then(({ data }) => { if (data) setCompanyName(data.name); });
  }, [companyId]);

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b bg-primary">
        <div className="mx-auto flex max-w-6xl items-center gap-3 px-6 py-4">
          <Link to="/app" className="flex h-9 w-9 items-center justify-center rounded-lg bg-[hsl(var(--brand-green))]">
            <FileStack className="h-4 w-4 text-white" />
          </Link>
          <div className="flex-1">
            <h1 className="text-base font-bold text-primary-foreground">Maestro {companyName || "Proveedores"}</h1>
            <p className="text-xs text-primary-foreground/60">Cuentas contables de la empresa</p>
          </div>
          <BackButton to="/app" />
        </div>
      </header>

      <main className="mx-auto max-w-6xl px-6 py-8">
        <Tabs defaultValue={initialTab} className="space-y-6">
          <TabsList>
            <TabsTrigger value="accounts">Cuentas contables</TabsTrigger>
            <TabsTrigger value="payment">Cuentas de pago</TabsTrigger>
            <TabsTrigger value="settings">Ajustes</TabsTrigger>
          </TabsList>

          <TabsContent value="accounts">
            {companyId && <UnifiedAccountsTab companyId={companyId} companyName={companyName} />}
          </TabsContent>

          <TabsContent value="payment">
            {companyId && <PaymentAccountsTab companyId={companyId} />}
          </TabsContent>

          <TabsContent value="settings">
            {companyId && <CompanySettingsTab companyId={companyId} />}
          </TabsContent>
        </Tabs>
      </main>
    </div>
  );
};

export default SupplierMasterPage;
